import route from '../../constants/routes';
import { getRouteWithCountryAndSlug, getRouteWithSlug } from '../../utils/common';
import { TP, PERFORMANCE_TYPES_ID } from '../../constants/consts';
import { venueFields } from '../../components/EditComponents/VenuesFieldsGroup/constants';
import { getFestivalRoute } from '../Festival/utils';

export const GET_PRODUCTION_DATA = 'app/ProductionUpdateSteps/GET_PRODUCTION_DATA';
export const SET_PRODUCTION = 'app/ProductionUpdateSteps/SET_PRODUCTION';

export const CREATE_PRODUCTION = 'app/ProductionUpdateSteps/CREATE_PRODUCTION';
export const UPDATE_PRODUCTION = 'app/ProductionUpdateSteps/UPDATE_PRODUCTION';

export const GET_COMPANIES = 'app/ProductionUpdateSteps/GET_COMPANIES';
export const CLEAN_OPTIONS_VALUES = 'app/ProductionUpdateSteps/CLEAN_OPTIONS_VALUES';

export const SET_PROFESSIONS = 'app/ProductionUpdateSteps/SET_PROFESSIONS';
export const SET_ROLES = 'app/ProductionUpdateSteps/SET_ROLES';
export const GET_PRODUCTION_NAMES = 'app/ProductionUpdateSteps/GET_PRODUCTION_NAMES';
export const GET_VENUES = 'app/ProductionUpdateSteps/GET_VENUES';
export const GET_PRODUCTION_CASTS = 'app/ProductionUpdateSteps/GET_PRODUCTION_CASTS';
export const CREATE_PRODUCTION_CASTS = 'app/ProductionUpdateSteps/CREATE_PRODUCTION_CASTS';
export const UPDATE_PRODUCTION_PERFORMANCES = 'app/ProductionUpdateSteps/UPDATE_PRODUCTION_PERFORMANCES';
export const GET_LIBRETTIST_NAMES = 'app/ProductionUpdateSteps/GET_LIBRETTIST_NAMES';
export const CREATE_COMPOSER = 'app/ProductionUpdateSteps/CREATE_COMPOSER';
export const SET_ADD_OPTION = 'app/ProductionUpdateSteps/SET_ADD_OPTION';
export const GET_PRODUCTION_DATES = 'app/ProductionUpdateSteps/GET_PRODUCTION_DATES';
export const GET_PRODUCTION_IMAGES = 'app/ProductionUpdateSteps/GET_PRODUCTION_IMAGES';
export const GET_PRODUCTION_VIDEO = 'app/ProductionUpdateSteps/GET_PRODUCTION_VIDEO';
export const ADD_SEVERAL_MEDIA = 'app/ProductionUpdateSteps/ADD_SEVERAL_MEDIA';
export const CLIENT_REMOVE_MEDIA = 'app/ProductionUpdateSteps/CLIENT_REMOVE_MEDIA';
export const UPDATE_MEDIA = 'app/ProductionUpdateSteps/UPDATE_MEDIA';
// artist specific data
export const GET_ARTIST_PRODUCTION_DATES = 'app/ProductionUpdateSteps/GET_ARTIST_PRODUCTION_DATES';
export const GET_ARTISTS_SUGGESTIONS = 'app/ProductionUpdateSteps/GET_ARTISTS_SUGGESTIONS';
export const GET_PRODUCTION_MEDIA_ATTRIBUTE_TYPES = 'app/ProductionUpdateSteps/GET_PRODUCTION_MEDIA_ATTRIBUTE_TYPES';
export const GET_FESTIVALS = 'app/ProductionUpdateSteps/GET_FESTIVALS';
export const GET_PERFORMANCE_CITIES = 'app/ProductionUpdateSteps/GET_PERFORMANCE_CITIES';
export const CLEAR_PERFORMANCE_CITIES = 'app/ProductionUpdateSteps/CLEAR_PERFORMANCE_CITIES';
export const GET_PERFORMANCE_STAGES = 'app/ProductionUpdateSteps/GET_PERFORMANCE_STAGES';
export const CLEAR_PERFORMANCE_STAGES = 'app/ProductionUpdateSteps/CLEAR_PERFORMANCE_STAGES';
export const GET_COMPANY_VENUES = 'app/ProductionUpdateSteps/GET_COMPANY_VENUES';
export const CLEAR_PRODUCTION = 'app/ProductionUpdateSteps/CLEAR_PRODUCTION';
export const GET_WORKS = 'app/ProductionUpdateSteps/GET_WORKS';
export const GET_PRODUCTION_SYNOPSIS = 'app/ProductionUpdateSteps/GET_PRODUCTION_SYNOPSIS';
export const DELETE_PRODUCTION_DOCUMENT = 'app/ProductionUpdateSteps/DELETE_PRODUCTION_DOCUMENT';
export const UPLOAD_PRODUCTION_DOCUMENTS = 'app/ProductionUpdateSteps/UPLOAD_PRODUCTION_DOCUMENTS';
export const UPDATE_PRODUCTION_SYNOPSIS_DOCUMENTS = 'app/ProductionUpdateSteps/UPDATE_PRODUCTION_SYNOPSIS_DOCUMENTS';
export const ADD_PRODUCTION_IMAGE = 'app/ProductionUpdateSteps/ADD_PRODUCTION_IMAGE';
export const ADD_PRODUCTION_VIDEO = 'app/ProductionUpdateSteps/ADD_PRODUCTION_VIDEO';
export const GET_COMPOSERS = 'app/ProductionUpdateSteps/GET_COMPOSERS';
export const GET_PRODUCTION_LIVESTREAMS = 'app/ProductionUpdateSteps/GET_PRODUCTION_LIVESTREAMS';
export const UPDATE_PRODUCTION_LIVESTREAM = 'app/ProductionUpdateSteps/UPDATE_PRODUCTION_LIVESTREAM';
export const GET_PRODUCTION_VIDEO_ON_DEMAND = 'app/ProductionUpdateSteps/GET_PRODUCTION_VIDEO_ON_DEMAND';
export const UPDATE_VIDEO_ON_DEMAND = 'app/ProductionUpdateSteps/UPDATE_VIDEO_ON_DEMAND';
export const GET_VIDEO_COST_TYPES = 'app/ProductionUpdateSteps/GET_VIDEO_COST_TYPES';
export const CREATE_DIGITAL_EVENT = 'app/ProductionUpdateSteps/CREATE_DIGITAL_EVENT';
export const DELETE_DIGITAL_EVENT = 'app/ProductionUpdateSteps/DELETE_DIGITAL_EVENT';
export const GET_IMAGE_FORMATS = 'app/ProductionUpdateSteps/GET_IMAGE_FORMATS';
export const GET_VIDEO_FORMATS = 'app/ProductionUpdateSteps/GET_VIDEO_FORMATS';

export const getPathForCompanyEditStep = ({ entity, production, step }) => ({
  pathname: `${getRouteWithCountryAndSlug(route.COMPANIES, entity)}/edit/modify-production`,
  query: { production_id: production?.id, step },
});

export const getPathForArtistsEditStep = ({ entity, production, step }) => ({
  pathname: `${getRouteWithSlug(route.ARTISTS, entity)}/edit/modify-production`,
  query: { production_id: production?.id, step },
});

export const getPathForFestivalEditStep = ({ entity, production, step }) => ({
  pathname: `${getFestivalRoute(entity)}/edit/modify-production`,
  query: { production_id: production?.id, step },
});

export const cardFields = {
  ...venueFields,
  time: {
    name: 'time',
    value: [],
    performanceField: 'time',
  },
  isTour: {
    name: PERFORMANCE_TYPES_ID.TOUR,
    value: false,
  },
  isFestivalPart: {
    name: PERFORMANCE_TYPES_ID.FESTIVAL,
    value: false,
  },
  festival: {
    name: 'festival',
    value: null,
  },
};

export const publishedCardFields = {
  cancel: {
    name: PERFORMANCE_TYPES_ID.CANCELLED,
    label: `${TP}.FN_EDITSEASON_MARK_AS_CANCELLED`,
    value: false,
  },
};

export const getFieldName = (parentFieldName, field) => `${parentFieldName}.${field?.name}`;

export const EDITING_PRODUCTION_ENTITY_TYPES = {
  COMPANY: 'company',
  ARTIST: 'artist',
  FESTIVAL: 'festival',
};

export const DIGITAL_EVENT_TYPES = {
  LIVESTREAM: 'livestream',
  VOD: 'video-on-denmand',
};
